import ExpenseDirection from './routeExpenseDirection';
export default ExpenseDirection;
